import styled from 'styled-components';
import { DEVICES } from '../../../config/appConfig';

export const CARD_STYLE = {
  backgroundImage: "url('/images/services/ourServiceFrame.svg')",
  backgroundPosition: 'center',
};

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-weight: 600;
  padding: 10px 10px;
  color: #000000;

  & img {
    height: 70px;
    width: 70px;
    mix-blend-mode: multiply;
    fill: #f07c00;
  }
  @media ${DEVICES.tablet} {
    img {
      height: 62px;
      width: 62px;
    }
  }

  @media ${DEVICES.mobile} {
    img {
      height: 56px;
      width: 56px;
    }
  }

  @media ${DEVICES.sMobile} {
    img {
      height: 48px;
      width: 48px;
    }
  }
`;

export const OurServicesContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  max-width: 1400px;
  margin: 0px auto;
`;

export const StyledConatiner = styled.div`
  width: 100%;
`;
